import React, { Fragment, memo, useContext, useEffect, useState } from 'react';
import cn from 'classnames';

import { IAnswer } from '../../../interfaces/answer.interface';
import { appConfig } from '../../../config/app.config';
import { AnswerType } from '../../../enums/answer-type.enum';
import { useCustomStylesOnHover } from '../../../hooks/use-custom-styles-on-hover.hook';
import { StylesContext } from '../../../contexts/styles-context/styles.context';
import ReactMarkDown from 'react-markdown';
import { Checkbox } from './checkbox';

import styles from './answer.module.scss';
import { CustomImage } from './custom-image';

interface AnswerProps {
  name: string;
  multiple?: boolean;
  answer: IAnswer
  tiles?: boolean;
  onChange?: (value: any, checked: boolean, answer: IAnswer) => void;
  card2Columns?: boolean;
  active: boolean;
  inForm?: boolean;
  anyAnswerChecked?: boolean;
  defaultChecked?: boolean;
  mode?: string;
}

export const Answer = memo((props: AnswerProps) => {
  const { name, multiple, answer, onChange, tiles, inForm, anyAnswerChecked, defaultChecked, mode } = props;
  const { styles: customStyles } = useContext(StylesContext);
  const { modifiedCustomStyles: {
    checkedPlainAnswer = {}, answerImageOverlay, answerImageOverlayChecked }, onMouseEnter, onMouseOut } = useCustomStylesOnHover(customStyles);

  const id = `${answer.id}_${name}_input`;

  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    if (answerImageOverlay) {
      console.log(answerImageOverlay.color);
      document.documentElement.style.setProperty('--imgCardOverlayColor1', answerImageOverlay.color)
      document.documentElement.style.setProperty('--imgCardOverlayColor2', answerImageOverlay.color)
      document.documentElement.style.setProperty('--imgCardOverlayColorChecked1', answerImageOverlayChecked.color)
      document.documentElement.style.setProperty('--imgCardOverlayColorChecked2', answerImageOverlayChecked.color)
    }
  }, [answerImageOverlay]);

  function changeHandler(event: { target: { value: any, checked: boolean } }) {
    setClicked(true);
    const { value, checked } = event.target;
    onChange && onChange(value, checked, answer);
  }

  //to pick the same answer if back to previous question
  function clickHandler() {
    if (answer.checked && !clicked) {
      changeHandler({ target: { value: answer.value, checked: true } });
    }
  }

  return (
    <section
      onClick={clickHandler}
      onMouseMoveCapture={() => answer.checked && onMouseEnter("checkedPlainAnswer")}
      onMouseOut={() => answer.checked && onMouseOut("checkedPlainAnswer")}
      style={(answer.checked && answer.type != "card") ? checkedPlainAnswer : {}}
      className={cn(styles.answer, styles[answer.size], styles[answer.type], styles[mode], { [styles.defaultChecked]: (answer.default || defaultChecked) && !anyAnswerChecked, [styles.checked]: answer.checked, [styles.tiles]: tiles, [styles.inForm]: inForm })}
    >
      <input
        name={name}
        value={answer.value}
        id={id}
        type={multiple ? "checkbox" : "radio"}
        checked={answer.checked || false}
        onChange={changeHandler}
      />
      <label className={styles.label} htmlFor={id}>
        {(answer.type == AnswerType.CARD) && <div className={cn(styles.imgCard)}>

          {(answer.img && props.active) ?
            <CustomImage
              active={props.active}
              imageObjectFit={answer.imageObjectFit}
              src={appConfig().assets_url + answer.img.url}
            />
            : <div className={styles.empty} />}
          {answer.icon && <div
            style={{ backgroundImage: `url(${appConfig().assets_url + answer.icon?.url})` }}
            className={cn(styles.icon, { [styles.active]: answer.checked })}
          />}
          <div className={styles.cardCheckbox}></div>
        </div>}

        {answer.type == AnswerType.EMOJI && <div className={cn(styles.emojiCard)}>
          <img src={appConfig().assets_url + appConfig().emoji_path + answer.emoji + ".png"} alt={answer.emoji} />
        </div>}

        <article className={styles[`content-${answer.type}`]}>
          <div className={styles.header}>
            {(answer.type == AnswerType.PLAIN || answer.type == AnswerType.DETAIL) && <Checkbox
              multiple={multiple}
              checked={answer.checked}
              defaultChecked={(answer.default || defaultChecked) && !anyAnswerChecked}
            />}
            <ReactMarkDown
              source={String(answer.value)}
              className={styles.description}
              escapeHtml={false}
              renderers={{
                paragraph: props => <Fragment children={
                  <h3 style={{ color: (answer.checked && answer.type != "card") ? (checkedPlainAnswer as any)?.color : "" }}>{props.children}</h3>
                } />
              }}
            />
          </div>
          {answer.description && <p>{answer.description}</p>}
        </article>
      </label>
    </section>
  );
});